import { render, staticRenderFns } from "./OrderStateUpdate.vue?vue&type=template&id=35e62da6&scoped=true"
import script from "./OrderStateUpdate.vue?vue&type=script&lang=js"
export * from "./OrderStateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e62da6",
  null
  
)

export default component.exports